import { Injectable } from '@angular/core';
import { Map } from 'immutable';

import { HeaderMappingItemEntity } from './header-mapping-item.entity';
import { HeaderMappingListEntity } from './header-mapping-list.entity';

@Injectable()
export class HeaderMappingListProvider {
	private readonly headerMappingList: HeaderMappingListEntity;

	public constructor() {
		this.headerMappingList = HeaderMappingListEntity.build([
			{
				field: 'label',
				alias: $localize`:i18n=@@depot.header.mapping.list.column.label:`,
				type: 'string',
				isSearchable: false,
				isFilterable: true,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 0,
				width: '30%',
			},
			{
				field: 'convertTo',
				alias: $localize`:i18n=@@depot.header.mapping.list.column.selectedType:`,
				type: '',
				isSearchable: false,
				isFilterable: false,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 1,
			},
			{
				field: 'dataType',
				alias: $localize`:i18n=@@depot.header.mapping.list.column.previousType:`,
				type: '',
				isSearchable: false,
				isFilterable: false,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 2,
				width: '4.5rem',
			},
			{
				field: 'format',
				alias: $localize`:i18n=@@depot.header.mapping.list.column.format:`,
				type: '',
				isSearchable: false,
				isFilterable: false,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 3,
			},
		]);
	}

	public getList(): HeaderMappingListEntity {
		return this.headerMappingList;
	}

	public setListElements(
		elements: Map<string, HeaderMappingItemEntity>
	): HeaderMappingListEntity {
		return this.headerMappingList.setElements(elements);
	}
}
